import { SeoHome } from "../components/Public/SeoTdk";
import Layout from "../components/Public/Layout";
import styles from "./index.module.scss";
import HomeBanner from "../components/Home/Banner";
import HomePart1 from "../components/Home/Part1";
import HomePart2 from "../components/Home/Part2";
import HomePart3 from "../components/Home/Part3";
import HomePart4 from "../components/Home/Part4";
import HomePart5 from "../components/Home/Part5";
import HomePart6 from "../components/Home/Part6";

export default function Home() {
  return (
    <div className="page">
      <SeoHome />
      <Layout>
        <div className={styles.home}>
          {/* banner */}
          <div className={styles.banner}>
            <HomeBanner />
          </div>

          <div className={styles.part1}>
            <HomePart1 />
          </div>

          <div className={styles.part2}>
            <HomePart2 />
          </div>

          <div className={styles.part3}>
            <HomePart3 />
          </div>

          <div className={styles.part4}>
            <HomePart4 />
          </div>

          <div className={styles.part5}>
            <HomePart5 />
          </div>

          <div className={styles.part6}>
            <HomePart6 />
          </div>
        </div>
      </Layout>
    </div>
  );
}
